



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

// models
import { PropOptionSelect } from '@/models'

@Component({
  name: 'Select'
})
export default class Select extends Vue {
	@Prop({ default: '' }) readonly label!: string
	@Prop({ default: false }) readonly required!: boolean
	@Prop({ default: '' }) readonly id!: string | number
	@Prop({ default: '' }) readonly name!: string
	@Prop({ default: '' }) readonly className!: string
	@Prop({ default: '' }) readonly iconClass!: string
	@Prop({ default: '' }) readonly default!: string
	@Prop({ default: '' }) readonly msgError!: string
	@Prop({ default: null }) readonly hasError!: boolean|null
	@Prop({ required: true }) readonly options!: PropOptionSelect[]

	value = this.default

	input () {
    this.$emit('input', this.value)
    this.$emit('change', this.value)
  }

	@Watch('default', { immediate: true, deep: true })
  changeOptions (newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.value = this.default
      this.input()
    }
  }
}
